<template>
    <table class="table-condensed">
        <thead>
        <tr>
            <th class="prev available" :class="disablePastDates()" >
                <button @click="$emit('prevMonth')" :disabled="disablePreviousDates()" :style="disablePreviousDates() ? 'cursor: not-allowed; pointer-events: auto;' : ''" style="border: none; background: #fff;">
                    <i :class="[arrowLeftClass]"></i>
                </button>
            </th>
            <th colspan="5" class="month">{{monthName}} {{year}}</th>
            <th class="next available" >
                <button @click="$emit('nextMonth')" style="border: none; background: #fff;">
                    <i :class="[arrowRightClass]"></i>
                </button>
            </th>
        </tr>
        </thead>
        <tbody>
        <tr>
            <th v-for="weekDay in locale.daysOfWeek">{{weekDay}}</th>
        </tr>
        <tr v-for="dateRow in calendar">
            <slot name="date-slot" v-for="date in dateRow">
                <td v-tooltip="{content: tooltipText, trigger: 'manual', show: date == selectedDate}" :class="dayClass(date)" @click="handleTooltip(date);" @mouseover="$emit('hoverDate', date)" @mouseout="hoverOut(); closeToolTip($event)">     
                    <div class="active-range" v-if="isActiveMonthDate(date)">
                        <span>{{date | dateNum}}</span>
                        <div class="price" v-if="showPrice">
                            <span :style="getPrice(date) == '0' ? {'visibility':'hidden'} : ''">{{ getPrice(date) }}</span>
                        </div>
                    </div>
                </td>
            </slot>
        </tr>
        </tbody>
    </table>
</template>

<script>
    import moment from 'moment'

    export default {
        name: 'calendar',
        props: ['clickedDate', 'clearToolTip', 'monthDate', 'locale', 'start', 'end', 'active', 'disablePrevDates', 'disabledDates', 'availableDates', 'showPrice', 'priceSymbol', 'maxDate', 'isCustomCalendar', 'canSelect'],
        data() {
            return {
                selectedDate: null,
                tooltipText: ""
            }
        },
        methods: {
            getMinStay(selectedDate) {
                var vm = this;
                let dt = new Date(vm.start)
                let momentDate = moment(vm.start).format("YYYY-MM-DD");
                let selectedmomentDate = moment(selectedDate).format("YYYY-MM-DD");
                let availableDate = this.availableDates.filter(function(availability) {
                    // return new Date(availability.date).setHours(0,0,0,0) == dt.setHours(0,0,0,0);
                    return availability.date == momentDate;
                })
                var noCheckOut = '';
                let selectedAvailableDate = this.availableDates.filter(function(availability) {
                    // return new Date(availability.date).setHours(0,0,0,0) == new Date(selectedDate).setHours(0,0,0,0);
                    return availability.date == selectedmomentDate;
                })
                let minNightDate = moment(availableDate[0].date, "YYYY-MM-DD").add("days", availableDate[0].min_night_stay).format("YYYY-MM-DD");
                
                if (selectedAvailableDate[0] != undefined && selectedmomentDate == momentDate) {
                    noCheckOut = selectedAvailableDate[0].nocheckout == true ? "\n No Check-Out" : '';
                    if (noCheckOut != "" &&selectedmomentDate >= minNightDate) {
                        return "No Check-Out";
                    }
                }
                var minStay = availableDate[0].min_night_stay != null ? availableDate[0].min_night_stay <= 1 ? '' : availableDate[0].min_night_stay + " Nights Minimum " : '';
            	return minStay + noCheckOut;
            },
            handleTooltip(date) {
                this.$emit('dateClick', date);
                var vm = this;
                setTimeout(() => {
                    if (vm.isCustomCalendar) {
                        var availableDate = this.availableDates.filter(function(availability) {
                            return new Date(availability.date).setHours(0,0,0,0) == new Date(date).setHours(0,0,0,0);
                        });
                        if (availableDate[0] == undefined) {
                            return
                        }
                        var dt = new Date(date);
                        //This if condition executes on checkout click and not show the tooltip 
                        //if clicked on prior to start date
                        var startDate = vm.start;
                        if ((dt.setHours(0,0,0,0) < new Date().setHours(0,0,0,0)) || (dt.setHours(0,0,0,0) < new Date(startDate).setHours(0,0,0,0))) {
                            // vm.selectedDate = null;
                            // vm.tooltipText = "";
                            return;
                        }
                        var nextDisableDates = vm.disabledDates.filter((date) => date >= moment(startDate).format("YYYY-MM-DD"));
                        if (nextDisableDates.length > 0) {
                            let selectedEndDate = moment(date, "YYYY-MM-DD");
                            let nextDisableDate = moment(nextDisableDates[0], "YYYY-MM-DD");
                            if (selectedEndDate >= nextDisableDate) {
                                // vm.selectedDate = null;
                                // vm.tooltipText = "";
                                return;
                            }
                        }
                        vm.getAvailableNights(date);
                        if (vm.canSelect) {
                            if ((vm.start &&  (vm.end == undefined || 
                            vm.start.setHours(0,0,0,0) == vm.end.setHours(0,0,0,0)) 
                            && dt.setHours(0,0,0,0) < vm.start.setHours(0,0,0,0))) {
                                // vm.selectedDate = null;
                                // vm.tooltipText = '';
                                return;
                            } else if (vm.start) {
                                vm.tooltipText = vm.getMinStay(date);
                            }
                        } else {
                            // This condition is not to show tooltip on checkout click
                            if (vm.start && vm.start.setHours(0,0,0,0) != vm.end.setHours(0,0,0,0)) {
                                this.tooltipText = "Checkout day"
                                this.clearToolTip();
                                //return;
                            }
                        }
                        vm.selectedDate = date;
                    }
                }, 50)
            },
            closeToolTip(event) {
                if (this.tooltipText == "Checkout day") {
                    this.selectedDate = null;
                    this.tooltipText = "";
                }
            },
            hoverOut() {
                // $(".be-no-check-in").removeClass("be-no-check-in");
                // $(".be-no-check-out").removeClass("be-no-check-out");
                // $(".min-stay-restriction-before-disable-date").removeClass("min-stay-restriction-before-disable-date");
                // $(".noCheckInCheckOut").removeClass("noCheckInCheckOut");
            },
            getAvailableNights(date) {
                let dt = new Date(date)
                let momentDate = moment(date).format("YYYY-MM-DD");
                let availableDate = this.availableDates.filter(function(availability) {
                    // return new Date(availability.date).setHours(0,0,0,0) == dt.setHours(0,0,0,0);
                    return availability.date == momentDate;
                })
                if (availableDate[0] != undefined) {
                    var minStay = availableDate[0].min_night_stay != null ? availableDate[0].min_night_stay <= 1 ? '' : availableDate[0].min_night_stay + " Nights Minimum " : '';
                    var nocheckin = availableDate[0].nocheckin == true ? "\n No Check-In" : '';
                    var nocheckout = availableDate[0].nocheckout == true ? "\n No Check-Out" : '';
                    
                    if (availableDate[0].nocheckin && this.start == undefined) {
                        minStay = '';
                        nocheckin = "No Check-In";
                    } else if (availableDate[0].nocheckin && this.start) {
                        nocheckin = '';
                    }

                    if (availableDate[0].nocheckout != '' && (this.start == undefined || this.start.setHours(0,0,0,0) == new Date(date).setHours(0,0,0,0))) {
                        nocheckout = '';
                    } else if (availableDate[0].nocheckout && this.start) {
                        nocheckout = "No Check-Out";
                        minStay = '';
                    }

                    if (availableDate[0].nocheckin && availableDate[0].nocheckout) {
                        minStay = '';
                        nocheckin = "No Check-In\n ";
                        nocheckout = "No Check-Out";
                    }
                    if (minStay == "" && nocheckin == "" && nocheckout == "") {
                        return;
                    }
                    this.tooltipText = minStay + nocheckin + nocheckout;
                    
                }
                // return availableDate[0] != undefined ? this.priceSymbol + " " +availableDate[0].price + " nights available \n no check-out" : '';
            },
            getPrice(date) { 
                let dt = new Date(date)
                let momentDate = moment(date).format("YYYY-MM-DD");
                let availableDate = this.availableDates.filter(function(availability) {
                    // return new Date(availability.date).setHours(0,0,0,0) == dt.setHours(0,0,0,0);
                    return availability.date == momentDate;
                })
                // return availableDate[0] != undefined ? this.priceSymbol + " " +availableDate[0].price : '0';

                if (availableDate[0] && availableDate[0].price === '') {
                    return '0';
                } else if (availableDate[0] && availableDate[0].price !== undefined) {
                    return this.priceSymbol + " " + availableDate[0].price;
                } else {
                    return '0';
                }
            },
            isActiveMonthDate(date) {
                let dt = new Date(date);
                return dt.getMonth() == this.month;
            },
            disablePreviousDates() {
                if (this.disablePrevDates) {
                    let dt = new Date();
                    return dt.getFullYear() == this.monthDate.getFullYear() && (dt.getMonth() == this.monthDate.getMonth() || dt.getMonth()+1 == this.monthDate.getMonth())
                }
            },
            disablePastDates() {
                if (this.disablePrevDates) {
                    let dt = new Date()
                    return {
                        'disable-prev-month': dt.getFullYear() == this.monthDate.getFullYear() && (dt.getMonth() == this.monthDate.getMonth() || dt.getMonth()+1 == this.monthDate.getMonth())
                    }
                } else {
                    return {}
                }
            },
            dayClass(date) {
                if (date) {
                    let dt = new Date(date)
                    let convertedDate = moment(date).format("YYYY-MM-DD");
                    let disabledDate = this.disabledDates.filter(function(inputDate) {
                         // return new Date(inputDate).setHours(0,0,0,0) == dt.setHours(0,0,0,0);
                        return inputDate == convertedDate;
                    }).length > 0;
                    let isMaxDate = this.maxDate != "" && dt.setHours(0,0,0,0) > new Date(this.maxDate).setHours(0,0,0,0);
                    let availableDate = this.availableDates.filter(function(availability) {
                        // return new Date(availability.date).setHours(0,0,0,0) == dt.setHours(0,0,0,0);
                        return availability.date == convertedDate;
                    })
                    var active = this.isActiveMonthDate(date) && (dt.setHours(0,0,0,0) == new Date(this.start).setHours(0,0,0,0) || dt.setHours(0,0,0,0) == new Date(this.end).setHours(0,0,0,0) || dt.setHours(0,0,0,0) == new Date(this.active).setHours(0,0,0,0));
                    var inRange = !disabledDate && dt.setHours(0,0,0,0)  >= new Date(this.start).setHours(0,0,0,0) && (dt.setHours(0,0,0,0)  <= new Date(this.active).setHours(0,0,0,0) || dt.setHours(0,0,0,0)  <= new Date(this.end).setHours(0,0,0,0));
                    return {
                        noCheckInCheckOut: this.clickedDate != null && this.clickedDate.setHours(0,0,0,0) == dt.setHours(0,0,0,0) && availableDate[0] != undefined && availableDate[0].nocheckin && availableDate[0].nocheckout,
                        'be-no-check-out': this.clickedDate != null && this.clickedDate.setHours(0,0,0,0) == dt.setHours(0,0,0,0) && availableDate[0] != undefined && availableDate[0].nocheckout,
                        disabled: !this.isActiveMonthDate(date),
                        disable: (this.isCustomCalendar && this.start && (this.end == undefined || this.start.setHours(0,0,0,0) == this.end.setHours(0,0,0,0)) && dt.setHours(0,0,0,0) < this.start.setHours(0,0,0,0)) || !this.isActiveMonthDate(date) || isMaxDate || disabledDate || this.disablePrevDates && dt.setHours(0,0,0,0) < new Date().setHours(0,0,0,0),
                        off: date.month() !== this.month,
                        weekend: date.isoWeekday() > 5,
                        today: dt.setHours(0,0,0,0) == new Date().setHours(0,0,0,0),
                        'pastDate': dt.setHours(0,0,0,0) < new Date().setHours(0,0,0,0),
                        'disabledDate': disabledDate,
                        active: active,
                        'in-range': inRange,
                        'check-in': new Date(this.start).setHours(0,0,0,0) == dt.setHours(0,0,0,0),
                        'check-out': this.isCustomCalendar ? new Date(this.start).setHours(0,0,0,0) != new Date(this.end).setHours(0,0,0,0) && new Date(this.end).setHours(0,0,0,0) == dt.setHours(0,0,0,0) : 
                        new Date(this.start).setHours(0,0,0,0) != new Date(this.active).setHours(0,0,0,0) && new Date(this.active).setHours(0,0,0,0) == dt.setHours(0,0,0,0)
                    }
                }
            }
        },
        computed: {
            arrowLeftClass() {
                return 'fa fa-chevron-left glyphicon glyphicon-chevron-left'
            },
            arrowRightClass() {
                return 'fa fa-chevron-right glyphicon glyphicon-chevron-right'
            },
            monthName() {
                return this.locale.monthNames[this.monthDate.getMonth()]
            },
            year() {
                return this.monthDate.getFullYear()
            },
            month () {
                return this.monthDate.getMonth()
            },
            calendar () {
                let month = this.month
                let year = this.monthDate.getFullYear()
                let daysInMonth = new Date(year, month, 0).getDate()
                let firstDay = new Date(year, month, 1)
                let lastDay = new Date(year, month, daysInMonth)
                let lastMonth = moment(firstDay).subtract(1, 'month').month()
                let lastYear = moment(firstDay).subtract(1, 'month').year()
                let daysInLastMonth = moment([lastYear, lastMonth]).daysInMonth()

                let dayOfWeek = firstDay.getDay()

                let calendar = []

                for (let i = 0; i < 6; i++) {
                    calendar[i] = [];
                }

                let startDay = daysInLastMonth - dayOfWeek + this.locale.firstDay + 1
                if (startDay > daysInLastMonth)
                    startDay -= 7

                if (dayOfWeek === this.locale.firstDay)
                    startDay = daysInLastMonth - 6;

                let curDate = moment([lastYear, lastMonth, startDay, 12, 0, 0]);
                for (let i = 0, col = 0, row = 0; i < 6 * 7; i++, col++, curDate = moment(curDate).add(1, 'day')) {
                    if (this.isActiveMonthDate(curDate)) {
                        if (i > 0 && col % 7 === 0) {
                            col = 0;
                            row++;
                        }
                        calendar[row][col] = curDate.clone();
                    }
                    curDate.hour(12);
                }

                return calendar
            }
        },
        filters: {
            dateNum(value) {
                return value.date()
            }
        }
    }
</script>

<style>
    td.today {
        font-weight: bold;
    }
    .tooltip {
  display: block !important;
  z-index: 10000;
}

.tooltip .tooltip-inner {
  background: #484848;
  color: #ffffff;
  border: 1px solid #484848;
  border-radius: 10px;
  padding: 3px 10px 3px;
}

.tooltip .tooltip-arrow {
  width: 0;
  height: 0;
  border-style: solid;
  position: absolute;
  margin: 5px;
  border-color: #484848;
  z-index: 1;
}

.tooltip[x-placement^="top"] {
  margin-bottom: 5px;
}

.tooltip[x-placement^="top"] .tooltip-arrow {
  border-width: 5px 5px 0 5px;
  border-left-color: transparent !important;
  border-right-color: transparent !important;
  border-bottom-color: transparent !important;
  bottom: -5px;
  left: calc(50% - 5px);
  margin-top: 0;
  margin-bottom: 0;
}

.tooltip[x-placement^="bottom"] {
  margin-top: 5px;
}

.tooltip[x-placement^="bottom"] .tooltip-arrow {
  border-width: 0 5px 5px 5px;
  border-left-color: transparent !important;
  border-right-color: transparent !important;
  border-top-color: transparent !important;
  top: -5px;
  left: calc(50% - 5px);
  margin-top: 0;
  margin-bottom: 0;
}

.tooltip[x-placement^="right"] {
  margin-left: 5px;
}

.tooltip[x-placement^="right"] .tooltip-arrow {
  border-width: 5px 5px 5px 0;
  border-left-color: transparent !important;
  border-top-color: transparent !important;
  border-bottom-color: transparent !important;
  left: -5px;
  top: calc(50% - 5px);
  margin-left: 0;
  margin-right: 0;
}

.tooltip[x-placement^="left"] {
  margin-right: 5px;
}

.tooltip[x-placement^="left"] .tooltip-arrow {
  border-width: 5px 0 5px 5px;
  border-top-color: transparent !important;
  border-right-color: transparent !important;
  border-bottom-color: transparent !important;
  right: -5px;
  top: calc(50% - 5px);
  margin-left: 0;
  margin-right: 0;
}

.tooltip.popover .popover-inner {
  background: #f9f9f9;
  color: black;
  padding: 24px;
  border-radius: 5px;
  box-shadow: 0 5px 30px rgba(black, .1);
}

.tooltip.popover .popover-arrow {
  border-color: #f9f9f9;
}

.tooltip[aria-hidden='true'] {
  visibility: hidden;
  opacity: 0;
  transition: opacity .15s, visibility .15s;
}

.tooltip[aria-hidden='false'] {
  visibility: visible;
  opacity: 1;
  transition: opacity .15s;
}
</style>


// WEBPACK FOOTER //
// src/components/DateRangePicker/components/Calendar.vue